/**
 * description:
 * Homepage "Gallery" preview grid — links out to the full gallery.
 */
import { Box, Typography } from "@mui/material";

import gob from "../../../pictures/updates/gallery-prev/gob.JPG";
import funday from "../../../pictures/updates/gallery-prev/funday.JPG";
import gbm from "../../../pictures/updates/gallery-prev/gbm.JPG";
import lechon from "../../../pictures/updates/gallery-prev/lechon.JPG";
import santa from "../../../pictures/updates/gallery-prev/santa.JPG";

const tileSx = {
  width: "100%",
  height: "100%",
  objectFit: "cover",
  borderRadius: "4px",
  display: "block",
};

const GalleryPreview = () => {
  return (
    <Box sx={{ bgcolor: "background.default", px: { xs: "20px", md: "48px" }, py: { xs: "48px", md: "90px" } }}>
      <Box sx={{ maxWidth: "1200px", mx: "auto" }}>
        <Typography variant="h2" sx={{ mb: "32px" }}>
          Gallery
        </Typography>
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: { xs: "1fr 1fr", md: "1.4fr 1fr 1fr" },
            gridTemplateRows: { xs: "repeat(3, 220px)", md: "260px 260px" },
            gap: "16px",
          }}
        >
          <Box component="img" src={gob} alt="GobblerFest" sx={{ ...tileSx, gridRow: { xs: "1", md: "1 / 3" }, gridColumn: { xs: "1 / 3", md: "auto" } }} />
          <Box component="img" src={funday} alt="Study nights" sx={tileSx} />
          <Box component="img" src={gbm} alt="D7 Dialogue Gala" sx={tileSx} />
          <Box component="img" src={lechon} alt="CS38 signups" sx={tileSx} />
          <Box component="img" src={santa} alt="Typhoon relief" sx={tileSx} />
        </Box>
        <Typography
          component="a"
          href="/gallery"
          variant="h6"
          sx={{
            display: "block",
            textAlign: "center",
            mt: "32px",
            color: "secondary.main",
            textDecoration: "none",
            width: "fit-content",
            mx: "auto",
            borderBottom: "3px solid",
            borderColor: "secondary.main",
            pb: "4px",
            fontSize: { xs: "1.1rem", sm: "1.3rem", md: "1.5rem", lg: "2rem" },
          }}
        >
          View Full Gallery →
        </Typography>
      </Box>
    </Box>
  );
};

export default GalleryPreview;
